import { useCallback, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { authQueries } from '../api/query';
import useAuthStore from './authStore';
function syncAuthStore(user: unknown) {
  const {
    setUser,
    setIsAuthenticated
  } = useAuthStore.getState();
  if (user) {
    setUser(user as Parameters<typeof setUser>[0]);
    setIsAuthenticated(true);
    return true;
  }
  setUser(null);
  setIsAuthenticated(false);
  return false;
}

/**
 * @param enabled  세션 fetch 활성화 여부.
 *   SSR 에서 세션 쿠키 부재가 확실한 경우 false 로 넘겨 불필요한 /user 호출을 막는다.
 *   (이때 store 는 `hydrate(false)` 로 이미 비로그인 확정 상태)
 */
export function useHydrateAuthSession({
  enabled = true
} = {}) {
  const {
    setIsLoading
  } = useAuthStore.getState();
  const {
    data,
    isLoading,
    isFetching,
    refetch
  } = useQuery({
    ...authQueries.session(),
    enabled
  });
  useEffect(() => {
    if (!enabled) return;
    setIsLoading(isLoading);
  }, [enabled, isLoading, setIsLoading]);
  useEffect(() => {
    if (!enabled) return;
    // getUserProfile이 401을 null로 변환하므로 data === null은 "비로그인" 의미
    if (isLoading) return;
    syncAuthStore(data);
  }, [enabled, data, isLoading]);
  const verifySession = useCallback(async () => {
    const result = await refetch();
    return syncAuthStore(result.data);
  }, [refetch]);
  return {
    data,
    isLoading: enabled ? isLoading : false,
    isFetching,
    verifySession
  };
}